import { render, staticRenderFns } from "./luckybox.vue?vue&type=template&id=7036671a&scoped=true"
import script from "./luckybox.vue?vue&type=script&lang=js"
export * from "./luckybox.vue?vue&type=script&lang=js"
import style0 from "./luckybox.vue?vue&type=style&index=0&id=7036671a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7036671a",
  null
  
)

export default component.exports